import axiosClient from "../axiosInstance";

const base = "/flags";

const getFlags = async () => {
  return axiosClient.get(base).then((response) => {
    return response.data;
  });
};

const getFlagById = async (flagId) => {
  return axiosClient.get(`${base}/${flagId}`).then((response) => {
    return response.data;
  });
};

const getFlagsByPlayer = async (playerName) => {
  return axiosClient
    .get(`${base}/player/${encodeURIComponent(playerName)}`)
    .then((response) => {
      return response.data;
    });
};

const createFlag = async (flagData) => {
  return axiosClient.post(base, flagData).then((response) => {
    return response.data;
  });
};

const updateFlag = async (flagData) => {
  return axiosClient
    .patch(`${base}/${flagData.id}/status`, { status: flagData.status })
    .then((response) => {
      return response.data;
    });
};

const deleteFlag = async (flagId) => {
  return axiosClient.delete(`${base}/${flagId}`).then((response) => {
    return response.data;
  });
};

const flagService = {
  getFlags,
  getFlagById,
  getFlagsByPlayer,
  createFlag,
  updateFlag,
  deleteFlag,
};

export default flagService;
